<template>
  <div class="z-card pb-0 border-0">
    <div class="z-card__title">
      <h4>{{ $t('pbx.stat.common.block.main') }}</h4>
    </div>

    <div class="z-card__body" style="position: relative">
      <div class="circle-row">
        <div class="circle-row__item  circle-row__item--green">
          <span>{{ $t('pbx.stat.type_answer.ANSWERED') }}</span>
          <span>{{ total.answered | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--yellow">
          <span>{{ $t('pbx.stat.type_answer.NO_ANSWER') }}</span>
          <span>{{ total.no_answer | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--crimson">
          <span>{{ $t('pbx.stat.type_answer.CANCELED') }}</span>
          <span>{{ total.canceled | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--purple">
          <span>{{ $t('pbx.stat.type_answer.REJECTED') }}</span>
          <span>{{ total.rejected | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--red">
          <span>{{ $t('pbx.stat.type_answer.FAILED') }}</span>
          <span>{{ total.failed | format }}</span>
        </div>
        <total-circle-chart :total="total" />
      </div>
      <total-column-chart />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import sumBy from 'lodash-es/sumBy';
  import TotalCircleChart from './total-circle-chart';
  import TotalColumnChart from './total-column-chart';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      TotalCircleChart,
      TotalColumnChart
    },
    filters: {
      format: function(val) {
        return parseInt(val).toLocaleString();
      }
    },
    computed: {
      ...mapGetters('pbx/stats/general/table', { items: DATA }),
      total() {
        return {
          answered: sumBy(this.items, 'answered'),
          no_answer: sumBy(this.items, 'no_answer'),
          canceled: sumBy(this.items, 'canceled'),
          rejected: sumBy(this.items, 'rejected'),
          failed: sumBy(this.items, 'failed'),
          total: sumBy(this.items, 'total')
        };
      }
    }
  };
</script>
